'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getCrossSaleData = exports.isInThai = exports.thaiCities = exports.isCheckVerify = exports.isPresentBeforeYesterday10PMOf = exports.spaBangkokBranchOptions = exports.isNumber = exports.getCookie = exports.isDusitApp = exports.currencies = exports.joinedTransferPickupOptions = exports.ticketHotelOptions = exports.basicPickupOptions = exports.airportPickupOptions = exports.pickupOptions = exports.minutes = exports.hours = exports.years = exports.months = exports.daysByMonth = exports.days = undefined;

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

exports.isMobile = isMobile;
exports.isServiceTime = isServiceTime;
exports.getInstantUrl = getInstantUrl;
exports.isMobileScreen = isMobileScreen;
exports.getTripLabels = getTripLabels;
exports.commaizeInt = commaizeInt;
exports.commaize = commaize;
exports.getResponse = getResponse;
exports.getDisplayPrice = getDisplayPrice;
exports.getDisplaySeasonedPrice = getDisplaySeasonedPrice;
exports.checkIdCardNumber = checkIdCardNumber;
exports.getRatingPoint = getRatingPoint;
exports.getHour = getHour;
exports.getMinute = getMinute;
exports.getCity = getCity;
exports.dateString = dateString;
exports.formatAMPM = formatAMPM;
exports.getTimeOptions = getTimeOptions;

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _momentTimezone = require('moment-timezone');

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

var _cookie = require('cookie');

var _cookie2 = _interopRequireDefault(_cookie);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_momentTimezone2.default.tz.setDefault('Asia/Bangkok');
function isMobile() {
  if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
    // Client side only
    return true;
  }
  return false;
}

function isServiceTime() {
  var start = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '10';
  var end = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '20';

  var hr = (0, _momentTimezone2.default)().format('HH');
  if (hr >= start && hr < end) {
    return true;
  }
  return false;
}

function getInstantUrl() {
  if (isServiceTime('06', '20')) {
    // if (moment().weekday() >= 5) {
    //   return '/inspiration/book-today-travel-tomorrow-weekend';
    // }
    // return '/inspiration/book-today-travel-tomorrow';
    return '/to/Any?date=tomorrow&is_instant=true';
  } else if (isServiceTime('20', '22')) {
    return '/inspiration/book-today-travel-tomorrow-joined-tour';
  }
  return null;
}

function isMobileScreen() {
  if (window && window.innerWidth <= 700) {
    return true;
  }
  return false;
}

function getTripLabels(trip) {
  var labels = [];
  if (trip.price_condition.text === 'All inclusive') {
    labels.push({ text: 'All inclusive', style: 'tag-inclusive', templateId: 'trip.item.all_inclusive' });
  }
  // if (trip.transportation === 'Private Car') {
  //   labels.push({text: 'Private car', style: 'tag-transport'});
  // }
  if (trip.search_information.is_hotel_pickup) {
    labels.push({ text: 'Free hotel pickup', style: 'tag-pickup', templateId: 'trip.item.free_hotel_pickup' });
  }
  // if (trip.tmt_tag) {
  //   labels.push({text: 'Exclusively', style: 'tag-tmt'});
  // }
  return labels;
}

function commaizeInt(num) {
  return (num ? num : 0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}

function commaize(num, currency) {
  if (currency === 'JPY') return commaizeInt(num);
  return (num ? num : 0).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}

function getResponse(response) {
  var time = 'about ' + _momentTimezone2.default.duration(response.average_time || 10800, 'seconds').humanize();
  var rate = ((response.rate || 1) * 100).toFixed(0) + '%';
  return {
    time: time,
    rate: rate
  };
}
// export function getDisplayPrice(quantity, fullPrices, omitBookingFee = false) {
//   let price = 0;
//   if (Array.isArray(fullPrices)) {
//     fullPrices.map((fp, index)=> {
//       if (index <= quantity - 1) {
//         price = omitBookingFee ? fp.seasonedDiscountedPerPerson : fp.displayPrice;
//       }
//     });
//   } else {
//     price = omitBookingFee ? fullPrices.seasonedDiscountedPerPerson : fullPrices.displayPrice;
//   }
//   return price;
// }

// export function getDisplaySeasonedPrice(quantity, fullPrices, omitBookingFee = false) {
//   let price = 0;
//   if (Array.isArray(fullPrices)) {
//     fullPrices.map((fp, index)=> {
//       if (index <= quantity - 1) {
//         price = omitBookingFee ? fp.seasoned : fp.displaySeasonedPrice;
//       }
//     });
//   } else {
//     price = omitBookingFee ? fullPrices.seasoned : fullPrices.displaySeasonedPrice;
//   }
//   return price;
// }

function getDisplayPrice(quantity, fullPrices) {
  var omitBookingFee = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var price = 0;
  if (Array.isArray(fullPrices)) {
    fullPrices.forEach(function (fp, index) {
      if (index <= quantity - 1) {
        price = omitBookingFee ? fp.seasonedDiscountedPerPerson : fp.displayPrice;
      }
    });
  } else {
    price = omitBookingFee ? fullPrices.seasonedDiscountedPerPerson : fullPrices.displayPrice;
  }
  return price;
}

function getDisplaySeasonedPrice(quantity, fullPrices) {
  var omitBookingFee = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var price = 0;
  if (Array.isArray(fullPrices)) {
    fullPrices.forEach(function (fp, index) {
      if (index <= quantity - 1) {
        price = omitBookingFee ? fp.seasoned : fp.displaySeasonedPrice;
      }
    });
  } else {
    price = omitBookingFee ? fullPrices.seasoned : fullPrices.displaySeasonedPrice;
  }
  return price;
}

function checkIdCardNumber(id) {
  if (id.length !== 13) return false;
  var sum = 0;
  for (var i = 0; i < 12; i++) {
    sum += parseFloat(id.charAt(i)) * (13 - i);
  }
  if ((11 - sum % 11) % 10 !== parseFloat(id.charAt(12))) return false;
  return true;
}

function getRatingPoint(point) {
  if (point.toFixed(1).toString().slice(-1) === '0') {
    return parseInt(point.toFixed(1), 10).toString();
  }
  return point.toFixed(1).toString();
}

var days = exports.days = _lodash2.default.fill(Array(31), 0).map(function (data, index) {
  return 1 + index;
});

var daysByMonth = exports.daysByMonth = function daysByMonth() {
  var month = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'January';
  var year = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1930;

  var dayOfMonth = (0, _momentTimezone2.default)(month + ' ' + year, 'MMMM YYYY').daysInMonth();
  return _lodash2.default.range(1, dayOfMonth + 1);
};

var months = exports.months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
var years = exports.years = _lodash2.default.fill(Array(80), 0).map(function (data, index) {
  return 1930 + index;
});

var hours = exports.hours = ['08', '09', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23', '00', '01', '02', '03', '04', '05', '06', '07'];
var minutes = exports.minutes = ['00', '15', '30', '45'];
var pickupOptions = exports.pickupOptions = ['08:00', '08:15', '08:30', '08:45', '09:00', '09:15', '09:30', '09:45', '10:00', '10:15', '10:30', '10:45', '11:00', '11:15', '11:30', '11:45', '12:00', '12:15', '12:30', '12:45', '13:00', '13:15', '13:30', '13:45', '14:00', '14:15', '14:30', '14:45', '15:00', '15:15', '15:30', '15:45', '16:00', '16:15', '16:30', '16:45', '17:00', '17:15', '17:30', '17:45', '18:00'];

var airportPickupOptions = exports.airportPickupOptions = ['00:00', '00:15', '00:30', '00:45', '01:00', '01:15', '01:30', '01:45', '02:00', '02:15', '02:30', '02:45', '03:00', '03:15', '03:30', '03:45', '04:00', '04:15', '04:30', '04:45', '05:00', '05:15', '05:30', '05:45', '06:00', '06:15', '06:30', '06:45', '07:00', '07:15', '07:30', '07:45', '08:00', '08:15', '08:30', '08:45', '09:00', '09:15', '09:30', '09:45', '10:00', '10:15', '10:30', '10:45', '11:00', '11:15', '11:30', '11:45', '12:00', '12:15', '12:30', '12:45', '13:00', '13:15', '13:30', '13:45', '14:00', '14:15', '14:30', '14:45', '15:00', '15:15', '15:30', '15:45', '16:00', '16:15', '16:30', '16:45', '17:00', '17:15', '17:30', '17:45', '18:00', '18:15', '18:30', '18:45', '19:00', '19:15', '19:30', '19:45', '20:00', '20:15', '20:30', '20:45', '21:00', '21:15', '21:30', '21:45', '22:00', '22:15', '22:30', '22:45', '23:00', '23:15', '23:30', '23:45'];

var basicPickupOptions = exports.basicPickupOptions = ['09:00', '10:00', '11:00', '12:00', '13:00', '14:00', '15:00', '16:00'];

var ticketHotelOptions = exports.ticketHotelOptions = ['09:00', '10:00', '11:00', '12:00', '13:00', '14:00', '15:00', '16:00', '17:00'];

var joinedTransferPickupOptions = exports.joinedTransferPickupOptions = ['10:00', '14:00', '18:00'];

function getHour(time) {
  return time.split(':')[0];
}
function getMinute(time) {
  return time.split(':')[1];
}

var currencies = exports.currencies = [{
  value: 'USD',
  label: 'US Dollar'
}, {
  value: 'EUR',
  label: 'EU Euro'
}, {
  value: 'GBP',
  label: 'British Pound'
}, {
  value: 'CNY',
  label: 'Chinese Yuan'
}, {
  value: 'JPY',
  label: 'Japanese Yen'
}, {
  value: 'SGD',
  label: 'Singapore Dollar'
}, {
  value: 'AUD',
  label: 'Australian Dollar'
}, {
  value: 'HKD',
  label: 'Hongkong Dollar'
}, {
  value: 'SEK',
  label: 'Swedish Krona'
}, {
  value: 'NOK',
  label: 'Norwegian Krone'
}, {
  value: 'CHF',
  label: 'Swiss Franc'
}, {
  value: 'RUB',
  label: 'Russian Ruble'
}, {
  value: 'MYR',
  label: 'Malaysian Ringgit'
}, {
  value: 'THB',
  label: 'Thai Baht'
}];

var isDusitApp = exports.isDusitApp = function isDusitApp() {
  if (!window || !window.document) return false;
  return _cookie2.default.parse(window.document.cookie).utm_campaign === 'Dusit app';
};

function getCity() {
  var path = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'Bangkok';

  return unescape(path);
}

var getCookie = exports.getCookie = function getCookie(key) {
  if (!window || !window.document) return null;
  return _cookie2.default.parse(window.document.cookie)[key];
};

var isNumber = exports.isNumber = function isNumber(n) {
  return !isNaN(parseFloat(n)) && isFinite(n);
};

function dateString(date) {
  var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'all';

  var format = void 0;
  var dateFormat = 'D MMMM YYYY';
  var timeFormat = 'HH:mm';
  if (type === 'all') {
    format = dateFormat + ' ' + timeFormat;
  } else if (type === 'date') {
    format = dateFormat;
  } else {
    format = timeFormat;
  }
  return (0, _momentTimezone2.default)(date).format(format);
}

function formatAMPM(momentDate) {
  return momentDate.format('h:mm A');
}

function getTimeOptions(start, end) {
  var step = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 60;

  var options = [];
  for (var i = start.clone(); i <= end; i = i.add(step, 'm')) {
    var t = i.format('HH:mm');
    options.push({
      value: t,
      label: t
    });
  }
  return options;
}

var spaBangkokBranchOptions = exports.spaBangkokBranchOptions = [{
  value: 'Silom',
  label: 'Silom'
}, {
  value: 'Sathorn',
  label: 'Sathorn'
}];

var isPresentBeforeYesterday10PMOf = exports.isPresentBeforeYesterday10PMOf = function isPresentBeforeYesterday10PMOf(date) {
  return (0, _momentTimezone2.default)().isBefore((0, _momentTimezone2.default)(date).startOf('day').subtract(2, 'h'));
};

var isCheckVerify = exports.isCheckVerify = function isCheckVerify() {
  var user = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var verification = user.verification;

  if (!verification) return false;

  var checkVerify = false;
  if (user.is_local_expert && verification) {
    checkVerify = verification.email_verified && verification.mobile_verified && verification.bank_book_verified && verification.id_card_selfie_verified && verification.id_card_verified && verification.fullname_birthdate_verified;
  }
  if (user.is_travel_agency) {
    checkVerify = checkVerify && (verification.business_registration_verified || verification.travel_agent_license_verified);
  }
  return checkVerify;
};

var thaiCities = exports.thaiCities = ['Bangkok', 'Hua Hin', 'Amnat Charoen', 'Ang Thong', 'Ayutthaya', 'Bueng Kan', 'Buriram', 'Chachoengsao', 'Chainat', 'Chaiyaphum', 'Chanthaburi', 'Chiang Mai', 'Chiang Rai', 'Chonburi', 'Chumphon', 'Kalasin', 'Kamphaeng Phet', 'Kanchanaburi', 'Khon Kaen', 'Krabi', 'Lampang', 'Lamphun', 'Loei', 'Lopburi', 'Mae Hong Son', 'Maha Sarakham', 'Mukdahan', 'Nakhon Nayok', 'Nakhon Pathom', 'Nakhon Phanom', 'Nakhon Ratchasima', 'Nakhon Sawan', 'Nakhon Si Thammarat', 'Nan', 'Narathiwat', 'Nong Bua Lamphu', 'Nong Khai City', 'Nonthaburi', 'Pathum Thani', 'Pattani', 'Pattaya', 'Phang Nga', 'Phatthalung', 'Phayao', 'Phetchabun', 'Phetchaburi', 'Phichit', 'Phitsanulok', 'Phrae', 'Phuket', 'Prachinburi', 'Prachuap Khiri Khan', 'Ranong', 'Ratchaburi', 'Rayong', 'Roi Et', 'Sa Kaeo', 'Sakon Nakhon', 'Samut Prakarn', 'Samut Sakhon', 'Samut Songkhram', 'Saraburi', 'Satun', 'Sing Buri', 'Sisaket', 'Songkhla', 'Sukhothai', 'Suphan Buri', 'Surat Thani', 'Surin', 'Tak', 'Trang', 'Trat', 'Ubon Ratchathani', 'Udon Thani', 'Uthai Thani', 'Uttaradit', 'Yala'];

var isInThai = exports.isInThai = function isInThai(destination) {
  return thaiCities.includes(destination);
};

var crossSaleData = {
  'mahanakhon skywalk': {
    product_url: 'https://www.takemetour.com/ticket/exclusive-rate-mahanakhon-skywalk-admission-ticket',
    original_price: 1250,
    final_price: 902.5,
    discount: '28%'
  },
  'sea life': {
    product_url: 'https://www.takemetour.com/ticket/sea-life-ocean-world-marine-magic',
    original_price: 990,
    final_price: 665,
    discount: '33%'
  }
};

var getCrossSaleData = exports.getCrossSaleData = function getCrossSaleData() {
  var optionTitle = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

  var dataKeys = (0, _keys2.default)(crossSaleData);
  var lowerTitle = optionTitle.toLowerCase();
  var matchKey = dataKeys.find(function (key) {
    return lowerTitle.includes(key);
  });
  if (matchKey) {
    return crossSaleData[matchKey];
  }
  return null;
};


//////////////////
// WEBPACK FOOTER
// ./src/utils/helpers.js
// module id = 19
// module chunks = 47